/* BOWKS | Thumbnail Navigation */

(() => {
  if (window.BowksThumbnailNavInstalled) return;
  window.BowksThumbnailNavInstalled = true;

  function initThumbnailNav() {
    document.querySelectorAll('.media_flex .thumbnail_list')
      .forEach((container) => {

        if (container.dataset.bowksNavReady === 'true') return;

        const list = container.querySelector(
          '.thumbnail-list.slider--tablet-up'
        );

        const up = container.querySelector(
          '.bowks-thumb-nav--up'
        );

        const down = container.querySelector(
          '.bowks-thumb-nav--down'
        );

        if (!list || !up || !down) return;

        container.dataset.bowksNavReady = 'true';

        function updateButtons() {
          const isDesktop = window.matchMedia(
            '(min-width: 990px)'
          ).matches;

          const maxScroll =
            list.scrollHeight - list.clientHeight;

          if (!isDesktop || maxScroll <= 2) {
            up.hidden = true;
            down.hidden = true;
            return;
          }

          up.hidden = list.scrollTop <= 2;
          down.hidden = list.scrollTop >= maxScroll - 2;
        }

        function scrollOne(direction) {
          const item = list.querySelector(
            '.thumbnail-list__item'
          );

          if (!item) return;

          const styles = window.getComputedStyle(list);
          const gap = parseFloat(styles.rowGap) || 0;

          const distance =
            item.getBoundingClientRect().height + gap;

          list.scrollBy({
            top: distance * direction,
            behavior: 'smooth'
          });
        }

        up.addEventListener('click', () => {
          scrollOne(-1);
        });

        down.addEventListener('click', () => {
          scrollOne(1);
        });

        list.addEventListener('scroll', updateButtons, {
          passive: true
        });

        window.addEventListener('resize', updateButtons);

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(updateButtons);
          observer.observe(list);
        }

        updateButtons();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initThumbnailNav
    );
  } else {
    initThumbnailNav();
  }

  document.addEventListener(
    'shopify:section:load',
    initThumbnailNav
  );
})();